import componentSizes from "@streeteasy/design-system/constants/componentSizes";

/**
 * @deprecated please use "@streeteasy/design-system/constants/componentSizes" instead
 */
const buttonSizes = {
  LG: componentSizes.LG,
  MD: componentSizes.MD,
  SM: componentSizes.SM
};

export default buttonSizes;
